import _cloneDeep from 'lodash/cloneDeep';

export default {
  transactionCodeResults: (state) => _cloneDeep(state.transactionCodeResults),
};
